const tapColors = [
  '#118D3F',
  '#139310',
  '#439D0B',
  '#82A608',
  '#AB9507',
  '#B16A07',
  '#B16A07',
  '#B16A07',
  '#AA2B1C',
  '#AA2B1C',
];

export const getTapColor = (tapScore: number): string => {
  return tapColors[Math.min(Math.floor(tapScore / 10), 9)];
};
